const CONFIG = {
  API_URL: 'https://api.frischerwind.com/api',
  // API_URL: 'https://api.frischerwind.lucid.build/api',
  // API_URL: 'https://frischerwind-api.ddev.site/api',
  ...(window.APP_CONFIG || {})
}

export default CONFIG



// WEBPACK FOOTER //
// ./client/config.js